import styles from "./Otp.module.scss";
import AuthService from "../../../api/services/auth.service";
import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import TitleUpdater from "../../../components/common/title/TitleUpdater";
import Input from "../../../components/common/input/Input";
import BannerImage from "../../../assets/images/login/BannerImage.png";
import Button from "../../../components/common/button/Button";
import { useLocalizedNavigate } from "../../../hooks/useLocalizedNavigate";
import { useTranslation } from "react-i18next";

const Otp = () => {
  const { t } = useTranslation("translation");
  const [errorMessage, setErrorMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useLocalizedNavigate();
  const { email } = useAuth();

  const validateOtp = (value: string) => {
    if (!value) {
      return t("errors.verificationCodeRequired");
    }
    if (!/^\d{6}$/.test(value)) {
      return t("errors.verificationCodeDigits");
    }
    return "";
  };

  const handleOtpChange = (value: string) => {
    setOtp(value);
    setOtpError(validateOtp(value));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const error = validateOtp(otp);
    if (error) {
      setOtpError(error);
      return;
    }
    setIsLoading(true);
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("otp", otp);
      formData.append("email", email);
      const res = await AuthService.sendOtp(formData);
      if (res.data) {
        navigate("/auth/login");
      }
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage(
        error.response.data.message ||
          error.response.data.error ||
          t("common_error"),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setErrorMessage("");
    try {
      const formData = new FormData();
      formData.append("email", email);
      await AuthService.resendOtp(formData);
      setErrorMessage(t("otp.success_resend") || "");
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        t("common_error");
      setErrorMessage(message);
    }
  };

  return (
    <div className={styles.otp}>
      <TitleUpdater title={t("otp.title")} />
      <div className="container">
        <div className={styles.content}>
          <div className={styles.img}>
            <img src={BannerImage} alt="" />
          </div>
          <form className={styles.form} onSubmit={handleSubmit}>
            <div>
              <h2 className={styles.title}>{t("otp.title")}</h2>
              <p className={styles.subtitle}>
                {t("otp.subtitle")} {email}
              </p>
            </div>
            {errorMessage && (
              <div
                className={
                  errorMessage.includes("resent")
                    ? styles.successMessage
                    : styles.errorMessage
                }
              >
                {errorMessage}
              </div>
            )}
            <div>
              <Input
                label={t("otp.verification_code") || ""}
                placeholder={t("otp.placeholders.verification_code") || ""}
                value={otp}
                onChange={(e) => handleOtpChange(e.target.value)}
                error={otpError}
                maxLength={6}
              />
              <p className={styles.info}>{t("otp.info")}</p>
              <p className={styles.resend}>
                {t("otp.resend_text")}{" "}
                <span className={styles.resendLink} onClick={handleResendOtp}>
                  {t("otp.resend_link")}
                </span>
              </p>
            </div>
            <Button
              type="submit"
              className={styles.button}
              disabled={isLoading || !!otpError}
              loading={isLoading}
            >
              {t("otp.verify_button")}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Otp;
